module.exports = __webpack_public_path__ + "img/lv1.1932aa4e.png";